export const defaultStrateryForPreferredDealType = 'PreferredDeals';
export const defaultStrategyForPrivateAuctionType = 'Private Auction Strategy';
export const defaultStrategyForGuaranteedDealType = 'GuaranteedDeals';
export const defaultBillingForPreferredDealType = 115707109393;
